<template>
 <AdminPanelEpicentrkMegogoPackageSellingHistoryEdit />
</template>

<script>
import AdminPanelEpicentrkMegogoPackageSellingHistoryEdit  from '../components/AdminPanelEpicentrkMegogoPackageSellingHistoryEdit.vue'
export default {
    data: () => ({}),
    components: {
        AdminPanelEpicentrkMegogoPackageSellingHistoryEdit
    },
    methods: {},
    mounted() {}
}
</script>
